import React from 'react'
import FirstSectionFeatured from './FirstSectionFeatured'
import FeatureSecondPage from './FeatureSecondPage'
import ThirdSectionFeatured from './ThirdSectionFeatured'

function FeaturedPlaylists() {
    return (
        <div>
            <FirstSectionFeatured />
            <FeatureSecondPage />
            <ThirdSectionFeatured />
        </div>
    )
}

export default FeaturedPlaylists
